import cx from 'classnames'
import type { CSSProperties } from 'react'

type Props = {
  className?: string
  spinnerDuration?: string
}

/**
 * A linear indeterminate spinner component that can be used to indicate loading states in the UI. The spinner is created using CSS animations and can be customized with different sizes and colors by passing additional class names through the `className` prop.
 */
export const LinearSpinner = ({
  className,
  spinnerDuration = '1.5s',
  ...restProps // Needed for e.g. tooltips
}: Props) => (
  <div
    className={cx(
      'h-0.5',
      'relative w-full overflow-hidden bg-current/10 animate-fade-in text-primary',
      className,
    )}
    role="status"
    data-testid="linearSpinner"
    style={{ '--spinner-duration': spinnerDuration } as CSSProperties}
    {...restProps}
  >
    <div
      className={cx(
        'absolute inset-y-0 left-0 w-full origin-left bg-current animate-linear-progress',
      )}
    />
  </div>
)
